import { render } from "./EditaCanalForm.vue?vue&type=template&id=00bafb93&scoped=true"
import script from "./EditaCanalForm.vue?vue&type=script&lang=js"
export * from "./EditaCanalForm.vue?vue&type=script&lang=js"

import "./EditaCanalForm.vue?vue&type=style&index=0&id=00bafb93&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bafb93"]])

export default __exports__